import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";
import {setSilent} from "../../../../redux/meta.js";
import {update} from "../../../app/setters/update.js";

export const useOdblokowanieSprawozdanie = (setErrors) => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch()

    return useMutation({
        mutationFn: (data) => update(`/oper/sprawozdanie/odblokuj`, data),
        onError: (err) => {
            if (typeof setErrors === 'function') {
                setErrors(err.response.data.errors);
            }
            toast.error('Błąd podczas operacji')
        },
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => {
                    const key = query.queryKey[0];
                    return (typeof key === 'string' && key.includes('rejestr/lista')) ||
                        key === 'lista_sprawozdan';
                },
            });
        },
        onSuccess: ({message, status}) => {
            dispatch(setSilent(true))
            status === 'success' ? toast.success(message) : toast.error(message)
        },
    })
}
